import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listArrayFilter'
})
export class ListArrayFilterPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param col
   * @param value
   * @param addUndefined
   */
  transform(items: any[], col: string, value: any, addUndefined: boolean): any {
    if (col.length === 0 || typeof value === 'undefined' || !value) {
      return items;
    }
    if (addUndefined) {
      return items.filter(x => {
        if (typeof x[col] === 'undefined') {
          return true;
        }
        return x[col].filter((y: any) => {
          return y === value;
        });
      });
    }
    return items.filter(x => {
      if (typeof x[col] === 'undefined') {
        return false;
      }
      return x[col].filter((y: any) => {
        return y === value;
      }).length;
    });
  }
}
